import { render, staticRenderFns } from "./ResourceCredentialsForm.vue?vue&type=template&id=2610d8a6&scoped=true"
import script from "./ResourceCredentialsForm.vue?vue&type=script&lang=js"
export * from "./ResourceCredentialsForm.vue?vue&type=script&lang=js"
import style0 from "./ResourceCredentialsForm.vue?vue&type=style&index=0&id=2610d8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2610d8a6",
  null
  
)

export default component.exports